// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w930","comment":"styles_comment__3r72s"};